<template>
  <div>
    <div>
      <div class="row">
        <div class="col-12">
          <div id="map" class="map-container rounded-lg">

          </div>
          <MapDataPOIDetailDialog />
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <input class="autocomplete-input my-3" type="text" v-model="search" placeholder="Search for POIs near the trail">
        </div>
      </div>

      <div class="row">
        <div class="col">
          <hr class="my-2">
          <div class="filter-bar">

            <span class="text-yellow p-3" style="white-space: nowrap;"><strong>Filter by type:</strong></span>

            <button type="button" class="btn d-flex align-items-center"  data-bs-toggle="dropdown" aria-expanded="false">
              All<span class="material-icons ml-1" style="pointer-events: none">arrow_drop_down</span>
            </button>

            <button type="button" class="btn text-muted" @click="clearAllFilter">
              Clear
            </button>

            <button type="button" class="btn text-muted" @click="clearAllFilter">
              &nbsp; &nbsp; &nbsp;
            </button>

            <div class="dropdown-menu bg-dark mt-2">
              <span v-for="poi in allPoiTypes" :key="poi.poi" class="dropdown-item" @click="poiClicked(poi)" role="button" tabindex="0">{{ poi.poi }}</span>
            </div>
          </div>
          <hr class="mb-4 mt-1">
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <h2 class="mb-4 display-5">
            <strong>Points of Interest along {{ this.trailName }}</strong>
          </h2>

          <div v-for="(poi, index) in searchResults" :key="poi.id">
            <amenity-app-location-result :poi="poi" :index="index + 1" />
          </div>
        </div>
      </div>
      <div v-if="searchResults.length == 0">
        <amenity-app-loading-spinner />
      </div>
    </div>
  </div>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import { mapState } from 'vuex';
import { POIUtility } from '../../../utils/models/POI';
import AmenityAppLoadingSpinner from './AmenityAppLoadingSpinner.vue';
import AmenityAppLocationResult from './AmenityAppLocationResult.vue';
import BaseMapDataPoiDetailDialog from "../../map_data_poi_dialog/MapDataPOIDetailDialog.vue";
import mapboxgl from "mapbox-gl";
import {HiikerMapStyle} from "../../../utils/models/MapStyles";
import {LayerRegistry} from "../../../utils/layer-registry";

export default defineComponent({
  data() {
    return {
      search: '',
      trailId: '',
      trailName: '',
      allPoiTypes: [],
      filteredPOITypes: [],
      searchResults: [],
      typesenseUrl: (window as any).typesenseUrl.replace(/['"]+/g, ''),
      typesenseSearchApiKey: (window as any).typesenseSearchApiKey.replace(/['"]+/g, ''),
    };
  },
  watch: {
    search(val) {
      this.fetchPOIsByString(val);
    },
    async filteredPOITypes(val) {
      await this.fetchPOIsByString("*");
    },
    trail() {
      this.setPOITypes();
    },
  },
  components: {
    MapDataPOIDetailDialog: BaseMapDataPoiDetailDialog,
    AmenityAppLocationResult,
    AmenityAppLoadingSpinner,
  },
  async mounted() {
    this.setupMap()
    this.trailId = window.trail_id;
    this.trailName = window.trail_name;

    if (!(window as any).trailBounds) {
      console.warn("window.trailBounds is not defined. Location filtering might not work as expected.");
    }

    $('#difficulty-dropdown').on('click', (e) => {
      e.stopPropagation();
    });
    this.setPOITypes();
    await this.fetchPOIsByString("*");
  },
  methods: {
    setupMap() {
      mapboxgl.accessToken = "pk.eyJ1IjoiaGlpa2VyLW1hcHMiLCJhIjoiY2x0YThyZHppMWhmejJqbzExODBuY3dveiJ9.nBrtnXgbzxpAx_953HCB-w"
      const map = new mapboxgl.Map({
        container: 'map',
        center: [window.trailCenterX, window.trailCenterY],
        zoom: 9,
      });
      map.on('load', () => {
        this.$store.dispatch('amenities/initialiseStore')
        this.$store.dispatch('amenities/mapInitialised')
        this.$store.dispatch('waypoints/initialiseStore')
        this.$store.dispatch('mapDataPOIs/addPoiSourceAndLayer')
        this.$store.dispatch('mapDataPOIs/activateClickHandler')
        this.$store.dispatch('mapDataPOIs/addAllPois')
      })
      map.setStyle(HiikerMapStyle.standard().styleUrl);
      window.map = map
      window.layerRegistry = new LayerRegistry(window.map);
      const canvas = map.getCanvasContainer();
      canvas.style.cursor = "crosshair";
    },
    poiClicked(poi) {
      if (this.filteredPOITypes.includes(poi.poi)) {
        this.filteredPOITypes = this.filteredPOITypes.filter((type) => type !== poi.poi);
      } else {
        this.filteredPOITypes.push(poi.poi);
      }
    },
    setPOITypes() {
      if (window.type == 'amenities') {
        this.allPoiTypes = POIUtility.amenities(this.trail);
      } else {
        this.allPoiTypes = POIUtility.accoms(this.trail);
      }
    },
    async fetchPOIsByString(string) {
      try {
        // --- Start: Parse WKT from window.trailBounds ---
        let locationFilterSegment = ''; // Initialize the location part of the filter
        const wktString = (window as any).trailBounds;

        if (wktString && typeof wktString === 'string' && wktString.toUpperCase().startsWith('POLYGON')) {
          try {
            // 1. Remove "POLYGON ((" and "))" case-insensitively and trim whitespace
            const coordPart = wktString.replace(/^POLYGON \(\(|\)\)$/gi, '').trim();

            // 2. Split into coordinate pairs (e.g., "lon1 lat1", "lon2 lat2")
            const pairs = coordPart.split(',');

            // 3. Map pairs to "lat, lon" format for Typesense, handling potential errors
            const typesenseCoords = pairs.map(pair => {
              const parts = pair.trim().split(/\s+/); // Split by one or more whitespace characters
              if (parts.length === 2) {
                const lon = parseFloat(parts[0]);
                const lat = parseFloat(parts[1]);
                // Check if parsing resulted in valid numbers
                if (!isNaN(lon) && !isNaN(lat)) {
                  return `${lat}, ${lon}`; // IMPORTANT: Typesense expects Lat, Lon order
                }
              }
              console.warn(`Could not parse coordinate pair: "${pair.trim()}" from WKT string.`);
              return null; // Return null for invalid pairs
            }).filter(coord => coord !== null); // Filter out any nulls (invalid pairs)

            // 4. Check if we have enough valid coordinates for a polygon (at least 3 points)
            if (typesenseCoords.length > 2) {
              // 5. Format for Typesense filter_by
              locationFilterSegment = ` && location:(${typesenseCoords.join(', ')})`;
            } else {
              console.warn('Not enough valid coordinate pairs parsed from WKT to form a polygon filter:', wktString);
            }
          } catch (parseError) {
            console.error('Error parsing WKT string:', wktString, parseError);
            // Decide fallback behavior: maybe fetch without location filter?
          }
        } else if (wktString) {
          console.warn(`window.trailBounds does not appear to be a valid WKT POLYGON string:`, wktString);
        } else {
          console.warn(`window.trailBounds is missing. Proceeding without location filter.`);
        }
        // --- End: Parse WKT ---


        const headers = {
          'Content-Type': 'text/plain', // Note: Usually should be 'application/json' for POST with JSON body
          'X-Typesense-API-Key': this.typesenseSearchApiKey,
        };

        // Determine which types to filter by
        const typesToFilter = (this.filteredPOITypes.length === 0 ? this.allPoiTypes : this.filteredPOITypes);
        // Ensure serverType exists and extract types, handling potential strings or objects
        const typeFilterValues = typesToFilter.map(poi => {
          // Assuming poi can be a string or an object with a serverType method/property
          if (typeof poi === 'object' && poi !== null && typeof poi.serverType === 'function') {
            return poi.serverType();
          } else if (typeof poi === 'object' && poi !== null && poi.poi) {
            return poi.poi; // Fallback if serverType isn't there but poi property is
          } else if (typeof poi === 'string'){
            return poi; // If it's already a string type
          }
          return null; // Skip invalid entries
        }).filter(type => type !== null); // Remove nulls

        // Construct the filter_by string
        // Note: Typesense filter_by array syntax is `field:=[value1, value2]` (no quotes if simple identifiers)
        // or `field:=['String Value 1', 'String Value 2']` (with quotes for strings)
        // Assuming your server types don't contain spaces or special chars requiring quotes:
        let filterByString = `type:=['POI']`; // Base filter
        if(typeFilterValues.length > 0){
          filterByString += ` && sub_type:=[${typeFilterValues.join(',')}]`;
          // If sub_types might contain spaces/special chars, you'd need:
          // filterByString += ` && sub_type:=[${typeFilterValues.map(t => `'${t}'`).join(',')}]`;
        }


        // Add the location filter segment if it was successfully created
        filterByString += locationFilterSegment;

        const queryPayload = {
          searches: [
            {
              query_by: "name,short_address,slug",
              sort_by: "_text_match:desc,impressions_count:desc",
              highlight_full_fields: "name,short_address,slug",
              collection: "searchable",
              q: string,
              facet_by: "sub_type,type",
              filter_by: filterByString, // Use the dynamically constructed string
              max_facet_values: 10,
              page: 1,
              per_page: 20,
            },
          ],
        };

        // Change content type header for JSON payload
        headers['Content-Type'] = 'application/json';

        const response = await fetch(`https://${this.typesenseUrl}/multi_search`, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify(queryPayload), // Send JSON payload
        });

        if (!response.ok) {
          const errorBody = await response.text();
          console.error('Typesense API Error:', response.status, errorBody, 'Request Payload:', queryPayload); // Log payload on error
          this.searchResults = [];
          return;
        }

        const data = await response.json();
        if (data.results && data.results[0] && data.results[0].hits) {
          this.searchResults = data.results[0].hits.map(hit => hit.document);
        } else {
          this.searchResults = [];
          // Log if no results found for debugging
          console.log('Typesense returned no results or unexpected structure:', data);
        }
      } catch (error) {
        console.error('Error fetching POIs by string (Typesense):', error);
        this.searchResults = [];
      }
    },
    clearAllFilter() {
      this.filteredPOITypes = [];
    },
  },
  computed: {
    trailPath() {
      return window.trailPath;
    },
    ...mapState({
      selectedPOI: (state) => state.poi.selectedPOI,
      trail: (state) => state.amenities.trail,
    }),
  },
});

</script>

<style>

.map-container {
  flex: 1 1 auto;
  max-width: 100%;
  z-index: 8;
  height: 400px;
}

.autocomplete-input {
  padding: 0.75em 3.4em;
  box-sizing: border-box;
  line-height: 1.5;
  flex: 1;
  background-color: transparent;
  border: none;
  background-repeat: no-repeat;
  background-position: 20px;
  background-image: url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNjY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCI+PGNpcmNsZSBjeD0iMTEiIGN5PSIxMSIgcj0iOCIvPjxwYXRoIGQ9Ik0yMSAyMWwtNC00Ii8+PC9zdmc+);
  background-size: 1em 1em;
  background-color: #2D2F35;
  color: #fff;
  z-index: 9;
  border-radius: 69px;
  width: 100%;
}

.autocomplete-input::placeholder {
  color: rgb(165, 165, 165);
}

.autocomplete-input:focus-visible {
  box-shadow: none;
  border: none;
  outline: none;
  background-color: #2d2f35;
  color: #fff;
}

.filter-bar{
  display: inline-flex;
  width: 100%;
  justify-content: flex-start;
}

.filter-container::-webkit-scrollbar {
  display: none;  /* Safari and Chrome */
}
.filter-container{
  overflow: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
  width: 100%;
  justify-content: start;
}
.filter-bar .btn{
  font-weight: 400;
  font-size: 1em;
  margin: .5em;
  padding: .5em .75em;
  white-space: nowrap;
}

.filter-bar .btn.active{
  background-color: #2c2c2c;
  color: #fff;
}

.filter-bar .dropdown-toggle::after{
  margin-left: 0.7em;
}

.filter-bar .dropdown-menu{
  background-color: #202020;
}
</style>
